import axios from 'axios';
import { jwtEncodeWithExpiry } from './jwt';

/* eslint no-param-reassign: 0 */

function onRequest (config) {
  if (localStorage.getItem('accessToken')) {
    const token = localStorage.getItem('accessToken');
    if (config.method === 'post') {
      if (!config.data) {
        config.data = {};
      }
      config.data.token = token;
      if (!config.params) {
        config.params = {};
      }
      config.params.token = token;
      config.data = {
        data: jwtEncodeWithExpiry(config.data),
      };
    } else {
      if (!config.params) {
        config.params = {};
      }
      config.params.token = token;
      config.params = {
        data: jwtEncodeWithExpiry(config.params),
        token,
      };
    }
  } else {
    if (!config.url.includes('oauth')) {
      console.log('Blocking axios request', config);
      return {
        headers: {},
        method: 'GET',
        url: '',
      };
    }
  }
  return config;
}

export default {
  /**
   * Attach the interceptor to the Axios instance.
   * @param instance The optional Axios instance on which to attach the
   * interceptor.
   * @returns The id of the interceptor attached to the axios instance.
   */
  attach (instance = axios) {
    return instance.interceptors.request.use(onRequest, error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      Promise.reject(new Error(error))
    }
    );
  },

  /**
   * Eject the Axios interceptor that is providing retry capabilities.
   * @param interceptorId The interceptorId provided in the config.
   * @param instance The axios instance using this interceptor.
   */
  detach (interceptorId, instance = axios) {
    instance.interceptors.request.eject(interceptorId);
  },
};
